import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  private readonly msg = 'Se opravičujemo, nimate ustreznih pravic';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return throwError(() => ({
            ...error,
            message: this.msg,
            error: {
              ...(typeof error.error === 'object' ? error.error : {}),
              error: this.msg,
              message: this.msg,
            },
          }));
        }

        return throwError(() => error);
      })
    );
  }
}